/**
 * The time of day, for the greeting. Four parts, by the reader's local hour.
 */
export type Daypart = 'morning' | 'afternoon' | 'evening' | 'night';

export const daypartOf = (hour: number): Daypart => {
    if (hour >= 5 && hour < 12) return 'morning';
    if (hour >= 12 && hour < 18) return 'afternoon';
    if (hour >= 18 && hour < 22) return 'evening';

    return 'night';
};

const GREETINGS: Record<Daypart, string> = {
    morning: 'Good morning',
    afternoon: 'Good afternoon',
    evening: 'Good evening',
    night: 'Up late',
};

/** "Good morning, Ana" — or just "Good morning" when there is no name to use. */
export const greetingFor = (hour: number, firstName: string | null): string => {
    const greeting = GREETINGS[daypartOf(hour)];

    return firstName === null || firstName.trim() === '' ? greeting : `${greeting}, ${firstName}`;
};

/** The hues a name can take: warm and cool tones that sit with the palette, none in the green band. */
export const HUES = [24, 232, 330, 190, 40, 265, 8, 205] as const;

/**
 * A stable hue for a name, so a team is always the same colour wherever it appears.
 * Deterministic from the characters, picked from `HUES`.
 */
export const hueFor = (name: string): number => {
    let hash = 0;

    for (const char of name) hash = (hash * 31 + (char.codePointAt(0) ?? 0)) % 360;

    return HUES[hash % HUES.length] ?? HUES[0];
};
